<template>
  <g>
    <g transform="scale(0.5)">
        <text transform="matrix(1 0 0 1 70 40)" class="name"
            >PIR{{ number }}</text
        >
        <circle id="pir-area" cx="250" cy="200" r="400" fill="none" />
        <g>
            <rect x="47.78" y="41.88" class="st0" width="400" height="299" />
            <rect x="57.78" y="51.88" class="st0" width="380" height="279" />
            <polygon
                class="st0"
                points="208.53,409 208.53,356.46 195.39,356.46 195.39,321 300.16,321 300.16,356.46 287.02,356.46
            287.02,409 "
            />
            <polygon
                class="st0"
                points="205.39,346.46 218.53,346.46 218.53,394.56 218.53,399 227.41,399 227.41,394.56 227.41,346.46
            243.34,346.46 243.34,394.56 243.34,399 252.22,399 252.22,394.56 252.22,346.46 268.14,346.46 268.14,394.56 268.14,399
            277.02,399 277.02,394.56 277.02,346.46 290.16,346.46 290.16,331 205.39,331"
            />
        </g>
        <g>
            <g>
                <path
                    class="st1"
                    d="M57.78,51.88v279h380v-279H57.78z M87.5,204.88c-7.46,0-13.5-6.04-13.5-13.5c0-7.46,6.04-13.5,13.5-13.5
                s13.5,6.04,13.5,13.5C101,198.83,94.96,204.88,87.5,204.88z M407.5,205c-7.46,0-13.5-6.04-13.5-13.5c0-7.46,6.04-13.5,13.5-13.5
                s13.5,6.04,13.5,13.5C421,198.96,414.96,205,407.5,205z"
                />
                <circle class="st2" cx="407.5" cy="191.5" r="16" />
                <circle class="st3" cx="77.43" cy="312.75" r="7.75" />
                <circle class="st3" cx="99.57" cy="312.75" r="7.75" />
                <circle class="st3" cx="407.5" cy="314.82" r="7.75" />
                <circle class="st3" cx="407.5" cy="292.68" r="7.75" />
            </g>
            <circle class="st2" cx="87.5" cy="191.5" r="16" />
        </g>
        <path
            class="st4"
            d="M373.53,324.25h-251.5c-2.76,0-5-2.24-5-5v-256c0-2.76,2.24-5,5-5h251.5c2.76,0,5,2.24,5,5v256
        C378.53,322.01,376.29,324.25,373.53,324.25z"
        />
        <g>
            <circle class="st5 pir-cover" cx="247.78" cy="191.75" r="125" />
            <g>
                <defs>
                    <circle id="SVGID_1_PIR" cx="247.78" cy="191.75" r="125" />
                </defs>
                <clipPath id="SVGID_2_PIR">
                    <use xlink:href="#SVGID_1_PIR" style="overflow:visible;" />
                </clipPath>
                <g class="st6">
                    <polygon
                        class="st7"
                        points="267.41,157.75 228.15,157.75 208.52,191.75 228.15,225.75 267.41,225.75 287.04,191.75 "
                    />
                    <polygon
                        class="st7"
                        points="267.41,225.5 228.15,225.5 208.52,259.5 228.15,293.5 267.41,293.5 287.04,259.5 "
                    />
                    <polygon
                        class="st7"
                        points="267.41,89.5 228.15,89.5 208.52,123.5 228.15,157.5 267.41,157.5 287.04,123.5"
                    />
                    <polygon
                        class="st7"
                        points="267.41,21.5 228.15,21.5 208.52,55.5 228.15,89.5 267.41,89.5 287.04,55.5"
                    />
                    <polygon
                        class="st7"
                        points="326.41,191.75 287.15,191.75 267.52,225.75 287.15,259.75 326.41,259.75 346.04,225.75"
                    />
                    <polygon
                        class="st7"
                        points="326.41,259.5 287.15,259.5 267.52,293.5 287.15,327.5 326.41,327.5 346.04,293.5"
                    />
                    <polygon
                        class="st7"
                        points="326.41,123.5 287.15,123.5 267.52,157.5 287.15,191.5 326.41,191.5 346.04,157.5"
                    />
                    <polygon
                        class="st7"
                        points="385.41,157.75 346.15,157.75 326.52,191.75 346.15,225.75 385.41,225.75 405.04,191.75"
                    />
                    <polygon
                        class="st7"
                        points="385.41,225.5 346.15,225.5 326.52,259.5 346.15,293.5 385.41,293.5 405.04,259.5"
                    />
                    <polygon
                        class="st7"
                        points="385.41,89.5 346.15,89.5 326.52,123.5 346.15,157.5 385.41,157.5 405.04,123.5"
                    />
                    <polygon
                        class="st7"
                        points="149.41,157.75 110.15,157.75 90.52,191.75 110.15,225.75 149.41,225.75 169.04,191.75"
                    />
                    <polygon
                        class="st7"
                        points="149.41,225.5 110.15,225.5 90.52,259.5 110.15,293.5 149.41,293.5 169.04,259.5"
                    />
                    <polygon
                        class="st7"
                        points="149.41,89.5 110.15,89.5 90.52,123.5 110.15,157.5 149.41,157.5 169.04,123.5"
                    />
                    <polygon
                        class="st7"
                        points="326.41,55.5 287.15,55.5 267.52,89.5 287.15,123.5 326.41,123.5 346.04,89.5"
                    />
                    <polygon
                        class="st7"
                        points="208.41,191.75 169.15,191.75 149.52,225.75 169.15,259.75 208.41,259.75 228.04,225.75"
                    />
                    <polygon
                        class="st7"
                        points="208.41,259.5 169.15,259.5 149.52,293.5 169.15,327.5 208.41,327.5 228.04,293.5"
                    />
                    <polygon
                        class="st7"
                        points="208.41,123.5 169.15,123.5 149.52,157.5 169.15,191.5 208.41,191.5 228.04,157.5"
                    />
                    <polygon
                        class="st7"
                        points="208.41,55.5 169.15,55.5 149.52,89.5 169.15,123.5 208.41,123.5 228.04,89.5"
                    />
                    <polygon
                        class="st7"
                        points="267.41,293.5 228.15,293.5 208.52,327.5 228.15,361.5 267.41,361.5 287.04,327.5"
                    />
                </g>
                <use
                    xlink:href="#SVGID_1_PIR"
                    style="overflow:visible;fill:none;stroke:#C1D1D1;stroke-width:5;stroke-miterlimit:10;"
                />
            </g>
        </g>
        <g>
            <g transform="translate(-9,0)">
                <defs>
                    <path
                        id="SVGID_3_PIR"
                        d="M218.53,339.41v55.15c0,2.45,1.99,4.44,4.44,4.44c2.45,0,4.44-1.99,4.44-4.44v-55.15
                    c0-2.45-1.99-4.44-4.44-4.44C220.52,334.97,218.53,336.96,218.53,339.41"
                    />
                </defs>
                <clipPath id="SVGID_4_PIR">
                    <use xlink:href="#SVGID_3_PIR" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                    id="SVGID_5_PIR"
                    gradientUnits="userSpaceOnUse"
                    x1="583.8383"
                    y1="984.5656"
                    x2="584.801"
                    y2="984.5656"
                    gradientTransform="matrix(9.2244 0 0 -9.2244 -5167.0439 9449.0459)"
                >
                    <stop offset="0" style="stop-color:#FFFFFF" />
                    <stop offset="1.868181e-08" style="stop-color:#EDEDED" />
                    <stop offset="5.778537e-08" style="stop-color:#CECECE" />
                    <stop offset="1.020836e-07" style="stop-color:#B2B2B2" />
                    <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                    <stop offset="2.106338e-07" style="stop-color:#8B8B8B" />
                    <stop offset="2.829549e-07" style="stop-color:#808080" />
                    <stop offset="3.843946e-07" style="stop-color:#797979" />
                    <stop offset="6.659740e-07" style="stop-color:#777777" />
                    <stop offset="0.1253" style="stop-color:#848484" />
                    <stop offset="0.4162" style="stop-color:#9F9FA0" />
                    <stop offset="0.6113" style="stop-color:#9C9C9D" />
                    <stop offset="0.7532" style="stop-color:#939394" />
                    <stop offset="0.8778" style="stop-color:#848384" />
                    <stop offset="0.9926" style="stop-color:#6F6E6E" />
                    <stop offset="1" style="stop-color:#6D6C6C" />
                </linearGradient>
                <g class="pin">
                    <rect
                        x="218.53"
                        y="334.97"
                        class="st8"
                        width="8.88"
                        height="64.03"
                    />
                    <rect
                        :id="`${pincode}PS`"
                        @click="onClick(`${pincode}PS`)"
                        class="pin-cover terminal snap"
                        x="210.53"
                        y="385.97"
                        width="25"
                        height="25"
                    ></rect>
                    <text transform="matrix(1 0 0 1 195 450)" class="pin-name"
                        >VCC</text
                    >
                </g>
            </g>
            <g transform="translate(9,0)">
                <defs>
                    <path
                        id="SVGID_6_PIR"
                        d="M268.14,339.41v55.15c0,2.45,1.99,4.44,4.44,4.44c2.45,0,4.44-1.99,4.44-4.44v-55.15
                    c0-2.45-1.99-4.44-4.44-4.44C270.13,334.97,268.14,336.96,268.14,339.41"
                    />
                </defs>
                <clipPath id="SVGID_7_PIR">
                    <use xlink:href="#SVGID_6_PIR" style="overflow:visible;" />
                </clipPath>

                <linearGradient
                    id="SVGID_8_PIR"
                    gradientUnits="userSpaceOnUse"
                    x1="589.216"
                    y1="984.5656"
                    x2="590.1788"
                    y2="984.5656"
                    gradientTransform="matrix(9.2244 0 0 -9.2244 -5167.0439 9449.0459)"
                >
                    <stop offset="0" style="stop-color:#FFFFFF" />
                    <stop offset="1.868181e-08" style="stop-color:#EDEDED" />
                    <stop offset="5.778537e-08" style="stop-color:#CECECE" />
                    <stop offset="1.020836e-07" style="stop-color:#B2B2B2" />
                    <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                    <stop offset="2.106338e-07" style="stop-color:#8B8B8B" />
                    <stop offset="2.829549e-07" style="stop-color:#808080" />
                    <stop offset="3.843946e-07" style="stop-color:#797979" />
                    <stop offset="6.659740e-07" style="stop-color:#777777" />
                    <stop offset="0.1253" style="stop-color:#848484" />
                    <stop offset="0.4162" style="stop-color:#9F9FA0" />
                    <stop offset="0.6113" style="stop-color:#9C9C9D" />
                    <stop offset="0.7532" style="stop-color:#939394" />
                    <stop offset="0.8778" style="stop-color:#848384" />
                    <stop offset="0.9926" style="stop-color:#6F6E6E" />
                    <stop offset="1" style="stop-color:#6D6C6C" />
                </linearGradient>
                <g class="pin">
                    <rect
                        x="268.14"
                        y="334.97"
                        class="st9"
                        width="8.88"
                        height="64.03"
                    />
                    <rect
                        :id="`${pincode}MS`"
                        @click="onClick(`${pincode}MS`)"
                        class="pin-cover terminal snap"
                        x="259.53"
                        y="385.97"
                        width="25"
                        height="25"
                    ></rect>
                    <text transform="matrix(1 0 0 1 240 450)" class="pin-name"
                        >GND</text
                    >
                </g>
            </g>
            <g>
                <defs>
                    <path
                        id="SVGID_9_PIR"
                        d="M243.34,339.41v55.15c0,2.45,1.99,4.44,4.44,4.44c2.45,0,4.44-1.99,4.44-4.44v-55.15
                    c0-2.45-1.99-4.44-4.44-4.44C245.33,334.97,243.34,336.96,243.34,339.41"
                    />
                </defs>
                <clipPath id="SVGID_10_PIR">
                    <use xlink:href="#SVGID_9_PIR" style="overflow:visible;" />
                </clipPath>
                <linearGradient
                    id="SVGID_11_PIR"
                    gradientUnits="userSpaceOnUse"
                    x1="586.5271"
                    y1="984.5656"
                    x2="587.4899"
                    y2="984.5656"
                    gradientTransform="matrix(9.2244 0 0 -9.2244 -5167.0439 9449.0459)"
                >
                    <stop offset="0" style="stop-color:#FFFFFF" />
                    <stop offset="1.868181e-08" style="stop-color:#EDEDED" />
                    <stop offset="5.778537e-08" style="stop-color:#CECECE" />
                    <stop offset="1.020836e-07" style="stop-color:#B2B2B2" />
                    <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                    <stop offset="2.106338e-07" style="stop-color:#8B8B8B" />
                    <stop offset="2.829549e-07" style="stop-color:#808080" />
                    <stop offset="3.843946e-07" style="stop-color:#797979" />
                    <stop offset="6.659740e-07" style="stop-color:#777777" />
                    <stop offset="0.1253" style="stop-color:#848484" />
                    <stop offset="0.4162" style="stop-color:#9F9FA0" />
                    <stop offset="0.6113" style="stop-color:#9C9C9D" />
                    <stop offset="0.7532" style="stop-color:#939394" />
                    <stop offset="0.8778" style="stop-color:#848384" />
                    <stop offset="0.9926" style="stop-color:#6F6E6E" />
                    <stop offset="1" style="stop-color:#6D6C6C" />
                </linearGradient>
                <g class="pin">
                    <rect
                        x="243.34"
                        y="334.97"
                        class="st10"
                        width="8.88"
                        height="64.03"
                    />
                    <rect
                        :id="`${pincode}SG`"
                        @click="onClick(`${pincode}SG`)"
                        class="pin-cover terminal snap"
                        x="234.53"
                        y="385.97"
                        width="25"
                        height="25"
                    ></rect>
                    <text transform="matrix(1 0 0 1 225 450)" class="pin-name"
                        >SIG</text
                    >
                </g>
            </g>
        </g>
        <rect x="205.39" y="331" class="st11" width="84.77" height="15.46" />
        <g
            v-if="on"
            id="pir-person"
            style="transform: scale(7) translate(50px, 50px)"
            @click="initDraggable"
        >
            <g :class="{ hide: !icon }">
                <circle
                    style="fill:#010002;"
                    cx="26.677"
                    cy="4.383"
                    r="4.383"
                />
                <path
                    style="fill:#010002;"
                    d="M40.201,28.096c-1.236-13.887-7.854-16.657-7.854-16.657s-6.396-3.845-13.129,1.052
            c-4.365,3.973-5.373,10.038-6.063,15.896c-0.349,2.977,4.307,2.941,4.653,0c0.412-3.496,1-7.008,2.735-9.999l-0.008,3.375
            l-0.032,16.219v12.867c0,1.383,1.014,2.506,2.438,2.506c1.423,0,2.578-1.123,2.578-2.506V32.457h2.278c0,4.309,0,14.144,0,18.451
            c0,3,4.652,3,4.652,0c0-4.309,0-8.619,0-12.927l0.197-16.251c0.002-1.551,0.004-2.937,0.004-3.901
            c1.859,3.046,2.473,6.664,2.896,10.265C35.895,31.037,40.55,31.073,40.201,28.096z"
                />
                <text transform="matrix(1 0 0 1 0 62.041)" class="st12"
                    >센서 가까이 드래그해보세요</text
                >
            </g>
        </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'PIRSensor',
  data () {
    return {
      on: false,
      icon: false,
      draggable: null,
      flag: false,
      socket: null
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    start (socket) {
      this.on = true
      this.socket = socket
      this.icon = true
      window.Draggable.get(`#${this.data.id}`).disable()
      this.initDraggable()
    },
    off () {
      this.on = false
      this.socket = null
      this.icon = false
      window.Draggable.get(`#${this.data.id}`).enable()
    },
    hitDetection () {
      if (window.Draggable.hitTest(`#${this.data.id} #pir-area`, '#pir-person')) {
        window.gsap.to(`#${this.data.id} .pir-cover`, 1.0, { css: { fill: '#ff6f61' } })
        store.commit('socket/sendMessage', { socket: this.socket, message: { value: 1 } })
      } else {
        window.gsap.to(`#${this.data.id} .pir-cover`, 1.0, { css: { fill: '#E1E5DE' } })
        store.commit('socket/sendMessage', { socket: this.socket, message: { value: 0 } })
      }
    },
    initDraggable () {
      if (this.on) {
        window.Draggable.create(`#${this.data.id} #pir-person`, {
          bounds: '#canvas',
          onDragEnd: () => this.hitDetection()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
rect.st0,
polygon.st0 {
    display: none;
}
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}
.pin-name {
    display: none;
    font-size: 28px;
}
.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
    .pin-name {
        display: block;
    }
}
.selected {
    & path.st1 {
        display: block;
        stroke-width: 6px;
        stroke: #ff6f61;
    }
}
.hide {
    display: none;
}
.show {
    display: block;
}
.name {
    font-size: 32px;
}
.st0 {
    fill: #d6d6d6;
}
.st1 {
    fill: #2c6439;
}
.st2 {
    fill: none;
    stroke: #255831;
    stroke-width: 5;
    stroke-miterlimit: 10;
}
.st3 {
    fill: #c1c1c1;
    stroke: #9b9b9b;
    stroke-width: 3;
    stroke-miterlimit: 10;
}
.st4 {
    fill: #d0dfd5;
}
.st5 {
    fill: #e1e5de;
}
.st6 {
    clip-path: url(#SVGID_2_PIR);
}
.st7 {
    fill: none;
    stroke: #c1d1d1;
    stroke-width: 5;
    stroke-miterlimit: 10;
}
.st8 {
    clip-path: url(#SVGID_4_PIR);
    fill: url(#SVGID_5_PIR);
}
.st9 {
    clip-path: url(#SVGID_7_PIR);
    fill: url(#SVGID_8_PIR);
}
.st10 {
    clip-path: url(#SVGID_10_PIR);
    fill: url(#SVGID_11_PIR);
}
.st11 {
    fill: #333333;
}
.st12 {
    font-size: 5px;
}
</style>
